import MSvg from '@centria-ui/assets/icons/m.svg'
import TSvg from '@centria-ui/assets/icons/t.svg'
import SadSvg from '@centria-ui/assets/icons/sad.svg'
import PdfSvg from '@centria-ui/assets/icons/pdf.svg'
import MicSvg from '@centria-ui/assets/icons/mic.svg'
import NmiSvg from '@centria-ui/assets/icons/nmi.svg'
import AddSVg from '@centria-ui/assets/icons/add.svg'
import AskSvg from '@centria-ui/assets/icons/ask.svg'
import EyeSvg from '@centria-ui/assets/icons/eye.svg'
import BlurSvg from '@centria-ui/assets/icons/blur.svg'
import StarSvg from '@centria-ui/assets/icons/star.svg'
import InfoSvg from '@centria-ui/assets/icons/info.svg'
import VisaSVg from '@centria-ui/assets/icons/visa.svg'
import CopySvg from '@centria-ui/assets/icons/copy.svg'
import LockSvg from '@centria-ui/assets/icons/lock.svg'
import BellSvg from '@centria-ui/assets/icons/bell.svg'
import HomeSvg from '@centria-ui/assets/icons/home.svg'
import ListSvg from '@centria-ui/assets/icons/list.svg'
import BookSvg from '@centria-ui/assets/icons/book.svg'
import ChatSvg from '@centria-ui/assets/icons/chat.svg'
import LeafSvg from '@centria-ui/assets/icons/leaf.svg'
import SendSvg from '@centria-ui/assets/icons/send.svg'
import PlaySvg from '@centria-ui/assets/icons/play.svg'
import GiftSvg from '@centria-ui/assets/icons/gift.svg'
import MedalSvg from '@centria-ui/assets/icons/medal.svg'
import MagicSvg from '@centria-ui/assets/icons/magic.svg'
import ShareSvg from '@centria-ui/assets/icons/share.svg'
import StarsSvg from '@centria-ui/assets/icons/stars.svg'
import ClockSvg from '@centria-ui/assets/icons/clock.svg'
import ImageSvg from '@centria-ui/assets/icons/image.svg'
import CheckSvg from '@centria-ui/assets/icons/check.svg'
import ClearSvg from '@centria-ui/assets/icons/clear.svg'
import CrossSvg from '@centria-ui/assets/icons/cross.svg'
import TrashSvg from '@centria-ui/assets/icons/trash.svg'
import WorldSvg from '@centria-ui/assets/icons/world.svg'
import ArrowSvg from '@centria-ui/assets/icons/arrow.svg'
import StartSvg from '@centria-ui/assets/icons/start.svg'
import GlassSvg from '@centria-ui/assets/icons/glass.svg'
import HeartSvg from '@centria-ui/assets/icons/heart.svg'
import CloudSvg from '@centria-ui/assets/icons/cloud.svg'
import RotateSvg from '@centria-ui/assets/icons/rotate.svg'
import PointsSvg from '@centria-ui/assets/icons/points.svg'
import LogoutSvg from '@centria-ui/assets/icons/logout.svg'
import PencilSvg from '@centria-ui/assets/icons/pencil.svg'
import PaypalSvg from '@centria-ui/assets/icons/paypal.svg'
import FilterSvg from '@centria-ui/assets/icons/filter.svg'
import SearchSvg from '@centria-ui/assets/icons/search.svg'
import WalletSvg from '@centria-ui/assets/icons/wallet.svg'
import QuotesSvg from '@centria-ui/assets/icons/quotes.svg'
import DollarSvg from '@centria-ui/assets/icons/dollar.svg'
import PersonSvg from '@centria-ui/assets/icons/person.svg'
import StripeSvg from '@centria-ui/assets/icons/stripe.svg'
import GridSvg from '@centria-ui/assets/icons/gridIcon.svg'
import OptionsSvg from '@centria-ui/assets/icons/options.svg'
import ArchiveSvg from '@centria-ui/assets/icons/archive.svg'
import DiagramSvg from '@centria-ui/assets/icons/diagram.svg'
import HistorySvg from '@centria-ui/assets/icons/history.svg'
import PrinterSvg from '@centria-ui/assets/icons/printer.svg'
import LibrarySvg from '@centria-ui/assets/icons/library.svg'
import ProfileSvg from '@centria-ui/assets/icons/profile.svg'
import ShortenSvg from '@centria-ui/assets/icons/shorten.svg'
import EnlargeSvg from '@centria-ui/assets/icons/enlarge.svg'
import XSquareSvg from '@centria-ui/assets/icons/x-square.svg'
import EyeHideSvg from '@centria-ui/assets/icons/eye-hide.svg'
import MicMuteSvg from '@centria-ui/assets/icons/mic-mute.svg'
import NoImageSvg from '@centria-ui/assets/icons/no-image.svg'
import FavoriteSvg from '@centria-ui/assets/icons/favorite.svg'
import CarouselSvg from '@centria-ui/assets/icons/carousel.svg'
import InfinitySvg from '@centria-ui/assets/icons/infinity.svg'
import ScheduleSvg from '@centria-ui/assets/icons/schedule.svg'
import Heading3Svg from '@centria-ui/assets/icons/heading3.svg'
import Heading4Svg from '@centria-ui/assets/icons/heading4.svg'
import BuildingSvg from '@centria-ui/assets/icons/building.svg'
import PasswordSvg from '@centria-ui/assets/icons/password.svg'
import OpenBookSvg from '@centria-ui/assets/icons/open-book.svg'
import WifiSlowSvg from '@centria-ui/assets/icons/wifi-slow.svg'
import WifiGoodSvg from '@centria-ui/assets/icons/wifi-good.svg'
import ParagraphSvg from '@centria-ui/assets/icons/paragraph.svg'
import ArrowLeftSvg from '@centria-ui/assets/icons/arrow-left.svg'
import HandIndexSvg from '@centria-ui/assets/icons/hand-index.svg'
import BriefCaseSvg from '@centria-ui/assets/icons/brief-case.svg'
import CheckListSvg from '@centria-ui/assets/icons/check-list.svg'
import CardImageSvg from '@centria-ui/assets/icons/card-image.svg'
import ListStarsSvg from '@centria-ui/assets/icons/list-stars.svg'
import CategoriesSvg from '@centria-ui/assets/icons/categories.svg'
import MaterCardSvg from '@centria-ui/assets/icons/master-card.svg'
import CreditCardSvg from '@centria-ui/assets/icons/credit-card.svg'
import MobileMenuSvg from '@centria-ui/assets/icons/mobile-menu.svg'
import TelephoneXSvg from '@centria-ui/assets/icons/telephone-x.svg'
import ChronometerSvg from '@centria-ui/assets/icons/chronometer.svg'
import CameraVideoSvg from '@centria-ui/assets/icons/camera-video.svg'
import WifiOfflineSvg from '@centria-ui/assets/icons/wifi-offline.svg'
import ArchiveFillSvg from '@centria-ui/assets/icons/archive-fill.svg'
import PersonVideoSvg from '@centria-ui/assets/icons/person-video.svg'
import ArrowSquareSvg from '@centria-ui/assets/icons/arrow-square.svg'
import PaintBucketSvg from '@centria-ui/assets/icons/paint-bucket.svg'
import EmojiLaughing from '@centria-ui/assets/icons/emoji-laughing.svg'
import HeartOutlineSvg from '@centria-ui/assets/icons/heart-outline.svg'
import WifiModerateSvg from '@centria-ui/assets/icons/wifi-moderate.svg'
import CapsLockFillSvg from '@centria-ui/assets/icons/capslock-fill.svg'
import ClockHistorySvg from '@centria-ui/assets/icons/clock-history.svg'
import ScheduleAlertSvg from '@centria-ui/assets/icons/schedule-alert.svg'
import ScheduleCheckSvg from '@centria-ui/assets/icons/schedule-check.svg'
import ScheduleRangeSvg from '@centria-ui/assets/icons/schedule-range.svg'
import ScheduleCrossSvg from '@centria-ui/assets/icons/schedule-cross.svg'
import CardCheckListSvg from '@centria-ui/assets/icons/card-checklist.svg'
import ListCheckFailSvg from '@centria-ui/assets/icons/list-check-fail.svg'
import SchedulePointsSvg from '@centria-ui/assets/icons/schedule-points.svg'
import GoogleCalendarSvg from '@centria-ui/assets/icons/google-calendar.svg'
import CameraVideoOffSvg from '@centria-ui/assets/icons/camera-video-off.svg'
import PersonWorkspaceSvg from '@centria-ui/assets/icons/person-workspace.svg'
import JournalBookmarkSvg from '@centria-ui/assets/icons/journal-bookmark.svg'
import FavoriteOutlineSvg from '@centria-ui/assets/icons/favorite-outline.svg'
import OutlookCalendarSvg from '@centria-ui/assets/icons/outlook-calendar.svg'
import ExclamationSquareSvg from '@centria-ui/assets/icons/exclamation-square.svg'
import ChevronDoubleDownSvg from '@centria-ui/assets/icons/chevron-double-down.svg'

export const MIcon = () => <MSvg />
export const TIcon = () => <TSvg />
export const SadIcon = () => <SadSvg />
export const PdfIcon = () => <PdfSvg />
export const MicIcon = () => <MicSvg />
export const EyeIcon = () => <EyeSvg />
export const AskIcon = () => <AskSvg />
export const AddIcon = () => <AddSVg />
export const NmiIcon = () => <NmiSvg />
export const BlurIcon = () => <BlurSvg />
export const StarIcon = () => <StarSvg />
export const InfoIcon = () => <InfoSvg />
export const GridIcon = () => <GridSvg />
export const BookIcon = () => <BookSvg />
export const ChatIcon = () => <ChatSvg />
export const LeafIcon = () => <LeafSvg />
export const VisaIcon = () => <VisaSVg />
export const CopyIcon = () => <CopySvg />
export const LockIcon = () => <LockSvg />
export const BellIcon = () => <BellSvg />
export const HomeIcon = () => <HomeSvg />
export const SendIcon = () => <SendSvg />
export const ListIcon = () => <ListSvg />
export const PlayIcon = () => <PlaySvg />
export const GiftIcon = () => <GiftSvg />
export const MedalIcon = () => <MedalSvg />
export const MagicIcon = () => <MagicSvg />
export const ShareIcon = () => <ShareSvg />
export const GlassIcon = () => <GlassSvg />
export const StarsIcon = () => <StarsSvg />
export const StartIcon = () => <StartSvg />
export const ClearIcon = () => <ClearSvg />
export const CrossIcon = () => <CrossSvg />
export const TrashIcon = () => <TrashSvg />
export const WorldIcon = () => <WorldSvg />
export const ArrowIcon = () => <ArrowSvg />
export const HeartIcon = () => <HeartSvg />
export const CheckIcon = () => <CheckSvg />
export const CloudIcon = () => <CloudSvg />
export const ClockIcon = () => <ClockSvg />
export const ImageIcon = () => <ImageSvg />
export const StripeIcon = () => <StripeSvg />
export const DollarIcon = () => <DollarSvg />
export const RotateIcon = () => <RotateSvg />
export const PointsIcon = () => <PointsSvg />
export const LogoutIcon = () => <LogoutSvg />
export const PencilIcon = () => <PencilSvg />
export const PersonIcon = () => <PersonSvg />
export const PaypalIcon = () => <PaypalSvg />
export const FilterIcon = () => <FilterSvg />
export const WalletIcon = () => <WalletSvg />
export const SearchIcon = () => <SearchSvg />
export const QuotesIcon = () => <QuotesSvg />
export const OptionsIcon = () => <OptionsSvg />
export const EyeHideIcon = () => <EyeHideSvg />
export const ArchiveIcon = () => <ArchiveSvg />
export const DiagramIcon = () => <DiagramSvg />
export const PrinterIcon = () => <PrinterSvg />
export const LibraryIcon = () => <LibrarySvg />
export const ProfileIcon = () => <ProfileSvg />
export const ShortenIcon = () => <ShortenSvg />
export const EnlargeIcon = () => <EnlargeSvg />
export const NoImageIcon = () => <NoImageSvg />
export const HistoryIcon = () => <HistorySvg />
export const MicMuteIcon = () => <MicMuteSvg />
export const XSquareIcon = () => <XSquareSvg />
export const CarouselIcon = () => <CarouselSvg />
export const FavoriteIcon = () => <FavoriteSvg />
export const BuildingIcon = () => <BuildingSvg />
export const PasswordIcon = () => <PasswordSvg />
export const WifiGoodIcon = () => <WifiGoodSvg />
export const InfinityIcon = () => <InfinitySvg />
export const WifiSlowIcon = () => <WifiSlowSvg />
export const OpenBookIcon = () => <OpenBookSvg />
export const Heading3Icon = () => <Heading3Svg />
export const Heading4Icon = () => <Heading4Svg />
export const ScheduleIcon = () => <ScheduleSvg />
export const ArrowLeftIcon = () => <ArrowLeftSvg />
export const HandIndexIcon = () => <HandIndexSvg />
export const BriefCaseIcon = () => <BriefCaseSvg />
export const CheckListIcon = () => <CheckListSvg />
export const ListStarsIcon = () => <ListStarsSvg />
export const ParagraphIcon = () => <ParagraphSvg />
export const CardImageIcon = () => <CardImageSvg />
export const MasterCardIcon = () => <MaterCardSvg />
export const CreditCardIcon = () => <CreditCardSvg />
export const CategoriesIcon = () => <CategoriesSvg />
export const MobileMenuIcon = () => <MobileMenuSvg />
export const TelephoneXIcon = () => <TelephoneXSvg />
export const ArchiveFillIcon = () => <ArchiveFillSvg />
export const ArrowSquareIcon = () => <ArrowSquareSvg />
export const CameraVideoIcon = () => <CameraVideoSvg />
export const ChronometerIcon = () => <ChronometerSvg />
export const WifiOfflineIcon = () => <WifiOfflineSvg />
export const PersonVideoIcon = () => <PersonVideoSvg />
export const PaintBucketIcon = () => <PaintBucketSvg />
export const EmojiLaughingIcon = () => <EmojiLaughing />
export const HeartOutlineIcon = () => <HeartOutlineSvg />
export const WifiModerateIcon = () => <WifiModerateSvg />
export const ClockHistoryIcon = () => <ClockHistorySvg />
export const CapsLockFillIcon = () => <CapsLockFillSvg />
export const ScheduleAlertIcon = () => <ScheduleAlertSvg />
export const ScheduleCheckIcon = () => <ScheduleCheckSvg />
export const CardCheckListIcon = () => <CardCheckListSvg />
export const ScheduleCrossIcon = () => <ScheduleCrossSvg />
export const ScheduleRangeIcon = () => <ScheduleRangeSvg />
export const ListCheckFailIcon = () => <ListCheckFailSvg />
export const CameraVideoOffIcon = () => <CameraVideoOffSvg />
export const SchedulePointsIcon = () => <SchedulePointsSvg />
export const GoogleCalendarIcon = () => <GoogleCalendarSvg />
export const PersonWorkspaceIcon = () => <PersonWorkspaceSvg />
export const OutlookCalendarIcon = () => <OutlookCalendarSvg />
export const FavoriteIconOutline = () => <FavoriteOutlineSvg />
export const JournalBookmarkIcon = () => <JournalBookmarkSvg />
export const ChevronDoubleDownIcon = () => <ChevronDoubleDownSvg />
export const ExclamationSquareIcon = () => <ExclamationSquareSvg />
